import {
  paymentActiveProvidersDefaultValue,
  paymentActiveProvidersFeature,
} from 'core/feature-flags/config';
import { useFeatureFlags } from 'core/feature-flags/hooks';

export const usePaymentActiveProvidersFeature = () => {
  const featureFlags = useFeatureFlags();

  return featureFlags.getFeatureValue(
    paymentActiveProvidersFeature,
    paymentActiveProvidersDefaultValue,
  );
};
